import { components } from '@doltech/pageManagement/dto';

export const SAMPLE_SPECIAL_OBJECT_VOID = 'sample-special-object-void';

export interface SampleSpecialObjectElementModel {
  id: string;
  sampleType: SampleType;
  record: components['schemas']['SampleDTO'];
  detail: any;
}

export const SAMPLE_TYPE = {
  W1: 'writing_task_1',
  W2A: 'writing_task_2_aca',
  W2G: 'writing_task_2_gen',
  S1: 'speaking_part_1',
  S2: 'speaking_part_2',
  S3: 'speaking_part_3',
} as const;

export type SampleType = typeof SAMPLE_TYPE[keyof typeof SAMPLE_TYPE];
